import { pushToDataLayer } from '@thg-commerce/enterprise-metrics/src/data_layer'

export const quickBuyModalDataTrackingCallbacks = {
  modalClicked: () => {
    return pushToDataLayer({
      type: 'elysiumEvent',
      eventData: {
        eventAction: 'Clicked',
        eventCategory: 'Product | quickBuy',
      },
    })
  },
  modalViewed: (productSku: string) => {
    return pushToDataLayer({
      type: 'elysiumEvent',
      eventData: {
        eventAction: 'Viewed',
        eventCategory: 'Product | quickBuy',
        eventLabelValue: productSku,
      },
    })
  },
  modalAddToBasket: (productSku: string) => {
    return pushToDataLayer({
      type: 'elysiumEvent',
      eventData: {
        eventAction: 'clicked',
        eventCategory: 'Product | quickBuy',
        eventLabel: 'Add to cart',
        eventLabelValue: productSku,
      },
    })
  },
  modalClose: (productSku: string) => {
    return pushToDataLayer({
      type: 'elysiumEvent',
      eventData: {
        eventAction: 'clicked',
        eventCategory: 'Product | quickBuy',
        eventLabel: 'close modal',
        eventLabelValue: productSku,
      },
    })
  },
  modalInformation: (productSku: string) => {
    return pushToDataLayer({
      type: 'elysiumEvent',
      eventData: {
        eventAction: 'clicked',
        eventCategory: 'Product | quickBuyMoreInformation',
        eventLabel: 'View more',
        eventLabelValue: productSku,
      },
    })
  },
}
